import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "./store";
import { User, UserScore, UserType } from "./Profile";
import { useAuthToken } from "./AuthProvider";
import close from "./img/close.svg";
import logo from "./img/enjuggernaut_plus_logo.png";
import pair_programming from "./img/pair_programming.svg";
import { toast } from "react-toastify";

import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";

interface SubscriptionParams {
  open_fn: (open: boolean) => void;
}

export function Subscription(params: SubscriptionParams) {
  const [inPaymentView, setInPaymentView] = React.useState(false);
  const [subId, setSubId] = React.useState("");
  const { token, isLoading, isAuthenticated } = useAuthToken();

  const modalRef = React.useRef<HTMLDialogElement>(null);

  async function getClientSecret() {
    try {
      const apiEndpoint =  "/api/subscription";

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await fetch(apiEndpoint, {
        method: "GET",
        headers: headers,
      });

      const responseData = await response.json();

      setSubId(responseData.client_secret);
    } catch (error) {
      console.log(error);
      toast.error("An error occured.");
    }
  }

  React.useEffect(() => {
    if (!isLoading) {
      getClientSecret();
    }
  }, [isLoading]);

  modalRef.current?.showModal();

  const stripe = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY == undefined
      ? ""
      : process.env.REACT_APP_STRIPE_PUBLIC_KEY
  );

  return (
    <div className="z-[1] bg-[rgba(0,0,0,0.7)]">
      <dialog ref={modalRef} className="z-[3] w-2/3 rounded-md">
        <button
          className="ml-auto"
          onClick={() => {
            params.open_fn(false);
            setInPaymentView(false);
          }}
        >
          <img className="industry-img scale-20" src={close} />
        </button>

        {inPaymentView && (
          <EmbeddedCheckoutProvider
            stripe={stripe}
            options={{ clientSecret: subId }}
          >
            <EmbeddedCheckout className="ml-auto" />
          </EmbeddedCheckoutProvider>
        )}

        {!inPaymentView && (
          <div className="flex flex-row bg-white p-4">
            <div className="flex w-full flex-col lg:w-2/3">
              <img src={logo} alt="logo" className="scale-50" />
              <div className="ml-4">
                <h1 className="font-code lg:text-lg xl:text-xl">
                  Join and get{" "}
                </h1>
                <h1 className="pt-2 font-code lg:text-lg xl:text-xl">
                  - <span className="font-bold">100 resume credits</span> per
                  month
                </h1>
                <h1 className="pt-2 font-code lg:text-lg xl:text-xl">
                  - <span className="font-bold">100 job credits</span> per month
                </h1>
                <h1 className="pt-2 font-code lg:text-lg xl:text-xl">
                  - <span className="font-bold">57% more cool</span>, in our
                  books
                </h1>
              </div>
              <button
                className="start-button mx-auto mt-8 block w-1/2 px-6 py-2 font-code font-bold md:py-2 md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl"
                onClick={() => {
                  setInPaymentView(true);
                }}
              >
                Continue
              </button>
            </div>
            <div className="collapse my-auto mr-8 w-1/3 lg:visible">
              <img src={pair_programming} alt="pair programming" className="" />
            </div>
          </div>
        )}
      </dialog>
    </div>
  );
}
